export default "__VITE_ASSET__b20943b4__"